<template>
    <div
        class="avatarMulti"
        :style="{
            width: `${sizeWrapCurrent}px`,
            height: `${sizeWrapCurrent}px`,
        }"
    >
        <div v-if="canShowCount" class="avatarMulti__count">
            <span> +{{ contacts.length - 1 }} </span>
        </div>
        <div
            v-for="(item, index) in contacts"
            v-bind:key="item.id"
            :class="classes"
            :style="styles(index)"
        >
            <div
                v-if="
                    item.email === 'support@salesmessage.com' ||
                        item.email === 'salesmessage@gmail.com'
                "
                :style="styles(index)"
                class="salesmessage-avatar"
            ></div>
            <avatar v-else :size="size" :contact="item" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: { type: Array, required: true },
        contact: { type: Object, required: true },
        sizeWrap: { type: Number, default: 32 },
        sizeAvatar: { type: Number, default: 24 },
        showCount: { type: Boolean, default: false },
    },

    data: () => ({
        contacts: [],
        sizeWrapCurrent: 0,
    }),

    computed: {
        canShowCount() {
            const contactLength = this.contacts.length - 1;

            return this.showCount && contactLength;
        },

        classes() {
            return {
                avatarMulti__item: true,
                avatarMulti__one: this.contacts.length === 1,
            };
        },

        size() {
            if (this.contacts.length === 1) {
                return this.sizeWrapCurrent;
            }

            return this.sizeAvatar;
        },
    },

    watch: {
        'items.length'(newLength, oldLength) {
            if (newLength !== oldLength) {
                this.init();
            }
        },

        'contact.id'(newId, oldId) {
            if (newId !== oldId) {
                this.init();
            }
        },

        'contacts.length'(length) {
            if (length > 1) {
                this.sizeWrapCurrent += 4;
            }
        },
    },

    methods: {
        init() {
            this.sizeWrapCurrent = this.sizeWrap;

            let contacts = [];

            if (this.items.length) {
                contacts = [...this.items];
            }

            if (this.contact) {
                const exist = contacts.find((contact) => contact.id === this.contact?.id);

                if (!exist) {
                    contacts.push(this.contact);
                }
            }

            this.contacts = contacts;
        },

        styles(index) {
            if (index === 0) {
                return {
                    left: 0,
                    bottom: 0,
                    width: `${this.contacts.length === 1 ? this.sizeWrapCurrent : this.sizeAvatar}px`,
                    height: `${this.contacts.length === 1 ? this.sizeWrapCurrent : this.sizeAvatar}px`,
                    zIndex: this.contacts.length - index,
                };
            } else if (this.contacts.length === index + 1) {
                return {
                    right: 0,
                    top: 0,
                    width: `${this.contacts.length === 1 ? this.sizeWrapCurrent : this.sizeAvatar}px`,
                    height: `${this.contacts.length === 1 ? this.sizeWrapCurrent : this.sizeAvatar}px`,
                    zIndex: this.contacts.length - index,
                };
            } else {
                return {
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    margin: 'auto',
                    width: `${this.contacts.length === 1 ? this.sizeWrap : this.sizeAvatar}px`,
                    height: `${this.contacts.length === 1 ? this.sizeWrap : this.sizeAvatar}px`,
                    zIndex: this.contacts.length - index,
                };
            }
        },
    },

    mounted() {
        this.init();
    },
};
</script>
